module.exports = __webpack_public_path__ + "static/media/iconHealthWatch.71cb0b08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconHealthWatch.svg
// module id = 887
// module chunks = 0